export const SIDEBAR_COLORS = {
  textPrimary: '#0A1E28',
  textSecondary: '#667A86'
} as const;

export const thinScrollbarSx = {
  '&::-webkit-scrollbar': {
    width: '6px'
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#C2D0DA',
    borderRadius: '100px'
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#A6B8C4'
  }
} as const;
